import { ApolloClient, ApolloLink, ApolloProvider, HttpLink, InMemoryCache } from '@apollo/client';
import {
  IonApp, setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import { AuthContext } from 'contexts/AuthContext';
import jwtDecode from "jwt-decode";
import { useContext, useEffect, useState } from 'react';
import Tabs from "./Tabs";
/* Theme variables */
import './theme/variables.css';


setupIonicReact({
  rippleEffect: false,
  mode: 'ios',
  swipeBackEnabled: false,
});

const App: React.FC = () => {
  const { authState, refreshToken } = useContext(AuthContext)
  const token = authState.token;
  const [client, setClient] = useState<any>({})

  const createApolloClient = (_token:string) => {
  
      //new  code
      const refreshLink = new TokenRefreshLink({
        accessTokenField: 'token',
        isTokenValidOrUndefined: () => {
          if (!authState.user) {
              return true;
          }
          if (typeof _token !== 'undefined' && _token && _token !== "null") {
            // console.log('token expires',new Date(jwtDecode<any>(_token).exp * 1000).toISOString(), new Date().toISOString());
            if(jwtDecode<any>(_token).exp * 1000 > Date.now())
              return true;
          }
          return false;
        },
        fetchAccessToken: async () => {
          if (!authState.user) {
            return null;
          }
          const token = await authState.user.getIdToken(true);
          refreshToken(token);
          _token = token;
          return token;
        },
        handleFetch: (token) => {
          _token = token;
        },
        handleResponse: (operation, accessTokenField) => (token:any) => {
          if (!token) return { token: null };
          _token = token;
          return { token: token };
        },
        handleError: (error) => {
          console.error('Cannot refresh access token:', error);
        },
      });

      const httpLink = new HttpLink({
        uri: 'https://api.oshiapp.com/v1/graphql',
       headers: {
              Authorization: `Bearer ${_token}`
            }
      });

      const link =  ApolloLink.from([refreshLink, httpLink]);


    return new ApolloClient({
      link: link,
      cache: new InMemoryCache(),
    });
  };

  useEffect(() => {
    if(token){
      setClient(createApolloClient(token));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[token])
  
  return (
    <ApolloProvider client={client}>
      <IonApp>
        <IonReactRouter>
            <Tabs />
        </IonReactRouter>
      </IonApp>
    </ApolloProvider>
)};

export default App;
